import styled from 'styled-components';

export const Divider = styled.div`
  display: flex;
  height: 238px;
`;

export const Division = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:first-child {
    padding-right: 24px;
    border-right: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  }

  &:last-child {
    padding-left: 24px;
  }
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors['neutral-80']};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

export const List = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
`;

export const ListItem = styled.button`
  padding: 5.5px 12px;
  border: 0 none;
  color: ${({ theme }) => theme.colors['neutral-100']};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  cursor: pointer;
  display: flex;
  width: 100%;
  justify-content: space-between;

  &:hover {
    background-color: ${({ theme }) => theme.colors['neutral-20']};

    & > div {
      color: ${({ theme }) => theme.colors['light-red']};
    }

    & > div > svg {
      fill: ${({ theme }) => theme.colors['light-red']};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.colors['neutral-30']};
  }

  & > div {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors['neutral-80']};
  }

  & > div > svg {
    fill: ${({ theme }) => theme.colors['neutral-80']};
    width: 14px;
    height: 14px;
    margin-right: 4px;
    transition: none;
  }
`;

export const PaginationLoader = styled.div`
  height: 60px;
  position: relative;
  display: block;

  & > div {
    width: 40px;
    height: 40px;
    position: absolute;
    left: calc(50% - 20px);
    top: 10px;
  }
`;
